module.exports = __webpack_public_path__ + "img/1967 unveristy chior.f9630e3d.png";